var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerClass},[(!_vm.isEmbedded)?_c('PerformanceHeader'):_vm._e(),_vm._v(" "),_c('PerformanceTable',{attrs:{"chatbots":_vm.chatbots}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3331ac64","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/DashBoard/Performance/PerformanceView.vue
// module id = null
// module chunks = 